const PRODUCTION_ORIGIN = 'https://hashi.paperculture.com'
const WORKERS_PREVIEW_PATTERN =
  /^https:\/\/[a-z0-9-]+-hashi\.paperculture\.workers\.dev$/

export const isLocalhost = (hostname = location.hostname): boolean =>
  hostname === 'localhost'

/**
 * Validates origins for postMessage and OAuth security. Localhost is matched
 * on any port — Salesforce OAuth redirects and CORS are configured for ports
 * 8095-8099 (both http and https) to support parallel local dev sessions.
 */
export const isAllowedOrigin = (origin: string): boolean =>
  origin.includes('://localhost') ||
  origin === PRODUCTION_ORIGIN ||
  WORKERS_PREVIEW_PATTERN.test(origin)
